import React, { useState, useEffect, useRef } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import "bootstrap/dist/css/bootstrap.min.css"


//styles/sass
import "./ScenarioList.scss"

function ScenarioList({scenarios, currentScenario, setCurrentScenario, model}) {

  const [menu, displayMenu] = useState(false)

  //Toggle to open and close Menu
  const toggle = () => displayMenu(!menu)
  

  //Function to select Table
  const selectItem = (name) => {
    setCurrentScenario(name)
    Window.loadScenario(name, model)
    toggle()
  }
 
  let dropdownRef = useRef()

  useEffect(() => {

    let handler = (event) => {
      if (!dropdownRef.current.contains(event.target)) {
        displayMenu(false)
      }
    }
    document.addEventListener("mousedown", handler)

    return () => {
      document.removeEventListener("mousedown", handler)
    }

  })

  // Here we should get the scenario list in localStorage
  // let itemsFiltered = dataSource.filter(item => item.title !== table.title)

  
  //We return the jsx
  return (
    <div ref={dropdownRef} className="ScenarioList">
      <div className="DropdownScenario">
        <div className="TopOptionScenario" onClick={toggle}>
          <h3 className="OptionSelectedScenario">{currentScenario}</h3>
          <FontAwesomeIcon className={menu ? "chevronUp" : "chevronDown"} icon={faChevronDown} />
        </div>
        <div className={menu ? "List_shown" : "List_hidden"}>
          <ul>
            {scenarios.map(name => (
              <li className="OptionScenario" onClick={() => selectItem(name)}>
                <h3 className="OptionName">{name}</h3>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default ScenarioList